import { LayoutDashboard, GraduationCap, IndianRupee, Settings, Users, UserPlus, List, ClipboardList, Wallet, BookOpen, UserCheck, CalendarDays, Tag, User, CalendarClock, Briefcase, Building2, TrendingUp, ArrowLeftRight, School, Receipt, Bus, Hotel, Package, Megaphone, BarChart3, Banknote, ClipboardCheck, ShieldAlert } from 'lucide-react';
import { PATHS } from '@/router/paths';
import { ROLES } from '@/constants/roles';

const ICON_MAP = {
  people: Users,
  badge: Briefcase,
  payments: IndianRupee,
  family_restroom: Users,
  account_balance_wallet: Wallet,
  school: GraduationCap,
  fact_check: UserCheck,
  assignment: ClipboardCheck,
  calendar_month: CalendarClock,
  directions_bus: Bus,
  hotel: Hotel,
  menu_book: BookOpen,
  inventory: Package,
  campaign: Megaphone,
  analytics: BarChart3,
  assessment: BarChart3,
  money: Banknote,
  list: List,
  person_add: UserPlus,
  trending_up: TrendingUp,
  swap_horiz: ArrowLeftRight,
  dashboard: LayoutDashboard,
  receipt: Receipt,
  groups: Users,
  settings: Settings,
};

const MODULE_ICON_MAP = {
  STUDENT: GraduationCap,
  STAFF: Briefcase,
  FEE: IndianRupee,
  PARENT: Users,
  EXPENSE: Wallet,
  INCOME: Banknote,
  ACADEMIC: School,
  ATTENDANCE: UserCheck,
  EXAM: ClipboardCheck,
  TIMETABLE: CalendarClock,
  TRANSPORT: Bus,
  HOSTEL: Hotel,
  LIBRARY: BookOpen,
  INVENTORY: Package,
  COMMUNICATION: Megaphone,
  REPORTS: BarChart3,
  PAYROLL: Banknote,
  SETTINGS: Settings,
};

const MENU_CONFIG_MAP = {
  STUDENT_DASHBOARD: {
    title: 'Student Dashboard',
    path: PATHS.STUDENTS,
    icon: LayoutDashboard,
  },
  STUDENT_LIST: {
    title: 'Student List',
    path: `${PATHS.STUDENTS}/list`,
    icon: Users,
  },
  STUDENT_ADMISSION: {
    title: 'Student Admission',
    path: `${PATHS.STUDENTS}/add`,
    icon: UserPlus,
  },
  STUDENT_PROMOTION: {
    title: 'Student Promotion',
    path: PATHS.STUDENTS_PROMOTE,
    icon: TrendingUp,
  },
  STUDENT_TRANSFER: {
    title: 'Student Transfer',
    path: '/students/transfer',
    icon: ArrowLeftRight,
  },
  LOG_STUDENT_ATTENDANCE: {
    title: 'Student Attendance',
    path: PATHS.STUDENT_ATTENDANCE_DAILY || '/attendance/student-attendance',
    icon: UserCheck,
  },

  STAFF_DIRECTORY: {
    title: 'Staff Directory',
    path: PATHS.STAFF_MANAGEMENT_STAFF || '/staff',
    icon: Users,
  },

  DEPARTMENTS: {
    title: 'Departments',
    path: PATHS.STAFF_MANAGEMENT_DEPARTMENTS || '/staff-management/departments',
    icon: Building2,
  },
  DESIGNATIONS: {
    title: 'Designations',
    path: PATHS.STAFF_MANAGEMENT_DESIGNATIONS || '/staff-management/designations',
    icon: Tag,
  },
  LEAVE_TYPES: {
    title: 'Leave Types',
    path: PATHS.STAFF_MANAGEMENT_LEAVE_TYPES || '/staff-management/leave-types',
    icon: CalendarDays,
  },
  LEAVE_REQUESTS: {
    title: 'Leave Requests',
    path: PATHS.LEAVES || '/leaves',
    icon: ClipboardList,
  },
  MY_LEAVES: {
    title: 'My Leave',
    path: PATHS.MY_LEAVES || '/leaves/my',
    icon: CalendarDays,
  },
  STAFF_DISCIPLINE: {
    title: 'Staff Discipline',
    path: PATHS.STAFF_MANAGEMENT_DISCIPLINE || '/staff-management/discipline',
    icon: ShieldAlert,
  },
  ATTENDANCE_SETTINGS: {
    title: 'Attendance Settings',
    path: PATHS.ATTENDANCE_SETTINGS || '/attendance/settings',
    icon: Settings,
  },
  MY_ATTENDANCE: {
    title: 'My Attendance',
    path: PATHS.MY_ATTENDANCE || '/attendance/my-attendance',
    icon: UserCheck,
  },
  MY_ATTENDANCE_HISTORY: {
    title: 'My Attendance History',
    path: PATHS.ATTENDANCE_MY_HISTORY || '/attendance/my-history',
    icon: CalendarDays,
  },
  ATTENDANCE_SCANNER: {
    title: 'Attendance Scanner',
    path: PATHS.ATTENDANCE_QR_SCANNER || '/attendance/qr-scanner',
    icon: UserCheck,
  },
  ATTENDANCE_OVERVIEW: {
    title: 'Attendance Overview',
    path: PATHS.ATTENDANCE_DAILY || '/attendance/daily',
    icon: LayoutDashboard,
  },
  ATTENDANCE_REPORTS: {
    title: 'Attendance Overview',
    path: PATHS.ATTENDANCE_DAILY || '/attendance/daily',
    icon: LayoutDashboard,
  },

  FEE_DASHBOARD: {
    title: 'Fee Dashboard',
    path: PATHS.FEES,
    icon: LayoutDashboard,
  },
  FEE_COLLECTION: {
    title: 'Fee Collection',
    path: PATHS.FEES_COLLECT,
    icon: Wallet,
  },
  ASSIGN_FEES: {
    title: 'Assign Fees',
    path: PATHS.FEES_ASSIGN,
    icon: ClipboardList,
  },
  FEE_TYPES: {
    title: 'Fee Types',
    path: PATHS.FEES_TYPES,
    icon: Tag,
  },
  FEE_STRUCTURES: {
    title: 'Fee Structures',
    path: PATHS.FEES_STRUCTURE,
    icon: List,
  },

  PARENT_LIST: {
    title: 'Parent List',
    path: PATHS.PARENTS || '/parents',
    icon: Users,
  },

  EXPENSES: {
    title: 'Expenses',
    path: PATHS.EXPENSES || '/expenses',
    icon: Wallet,
  },
  EXPENSE_DASHBOARD: {
    title: 'Expenses Dashboard',
    path: PATHS.EXPENSE_DASHBOARD || '/expenses/dashboard',
    icon: LayoutDashboard,
  },
  EXPENSE_CATEGORY: {
    title: 'Expense Category',
    path: PATHS.EXPENSE_CATEGORIES || '/expenses/categories',
    icon: Tag,
  },
  EXPENSE_LIST: {
    title: 'Expense List',
    path: PATHS.EXPENSES || '/expenses',
    icon: Wallet,
  },

  INCOME_DASHBOARD: {
    title: 'Income Dashboard',
    path: PATHS.INCOME_DASHBOARD || '/income/dashboard',
    icon: LayoutDashboard,
  },
  INCOMES: {
    title: 'Incomes',
    path: PATHS.INCOMES || '/income',
    icon: Banknote,
  },
  INCOME_LIST: {
    title: 'Incomes',
    path: PATHS.INCOMES || '/income',
    icon: Banknote,
  },
  INCOME_CATEGORIES: {
    title: 'Income Categories',
    path: PATHS.INCOME_CATEGORIES || '/income/categories',
    icon: Tag,
  },
  INCOME_CATEGORY: {
    title: 'Income Categories',
    path: PATHS.INCOME_CATEGORIES || '/income/categories',
    icon: Tag,
  },
};

export function isValidModule(mod) {
  if (!mod || mod === 'no school id' || mod === 'hello' || mod === 'none') return false;

  if (typeof mod === 'string') {
    const uppercaseModName = mod.toUpperCase();
    return Boolean(MODULE_ICON_MAP[uppercaseModName]);
  }

  if (typeof mod === 'object') {
    const modName = (mod.name || mod.code || '').toUpperCase();
    const hasMenus = Array.isArray(mod.menus) && mod.menus.length > 0;
    return Boolean(MODULE_ICON_MAP[modName]) || hasMenus || Boolean(mod.route && mod.route !== '#');
  }

  return false;
}

export function buildDynamicNavigation(userModules = [], userRole = '') {
  const roleUpper = String(userRole || '').toUpperCase();
  const isSuperAdmin = roleUpper === 'SUPER_ADMIN';
  const isOrgAdmin = roleUpper === 'ORGANIZATION_ADMIN' || roleUpper === 'ORG_ADMIN';

  // Filter out invalid/placeholder module entries
  const validModules = Array.isArray(userModules)
    ? userModules.filter(isValidModule)
    : [];

  // If not super admin and no modules are assigned, return empty navigation
  if (!isSuperAdmin && validModules.length === 0) {
    return [];
  }

  const navItems = [];

  // Only include top Dashboard tab for Organization Admin
  if (isOrgAdmin) {
    navItems.push({
      id: 'dashboard',
      title: 'Dashboard',
      path: PATHS.DASHBOARD,
      icon: LayoutDashboard,
    });
  }

  if (!Array.isArray(userModules) || userModules.length === 0) {
    return navItems;
  }

  const sortedModules = [...validModules]
    .filter((mod) => {
      const modData = mod.module || mod;
      const modName = (modData.name || modData.id || '').toUpperCase();
      return modName !== 'SETTINGS';
    })
    .sort((a, b) => {
      const aData = a.module || a;
      const bData = b.module || b;
      const orderA = aData.sort_order != null ? Number(aData.sort_order) : 999;
      const orderB = bData.sort_order != null ? Number(bData.sort_order) : 999;
      return orderA - orderB;
    });

  sortedModules.forEach((mod) => {
    const modData = mod.module || mod;
    const modName = (modData.name || '').toUpperCase();
    const modDisplayName = modData.display_name || modData.name || 'Module';
    const modIcon = ICON_MAP[modData.icon] || MODULE_ICON_MAP[modName] || Briefcase;

    const rawMenus = modData.menus || [];
    const sortedMenus = [...rawMenus].sort((a, b) => {
      const orderA = a.sort_order != null ? Number(a.sort_order) : 999;
      const orderB = b.sort_order != null ? Number(b.sort_order) : 999;
      return orderA - orderB;
    });

    const children = [];

    sortedMenus.forEach((menu) => {
      const menuName = (menu.name || '').toUpperCase();
      const mapped = MENU_CONFIG_MAP[menuName];

      const childTitle = menu.display_name || mapped?.title || menuName;
      let childPath = mapped?.path;

      // Explicit route overrides for Expense and Income module menus
      if (menuName === 'EXPENSE_DASHBOARD' || menuName === 'EXPENSES_DASHBOARD') {
        childPath = PATHS.EXPENSE_DASHBOARD || '/expenses/dashboard';
      } else if (menuName === 'EXPENSE_CATEGORY' || menuName === 'EXPENSE_CATEGORIES') {
        childPath = PATHS.EXPENSE_CATEGORIES || '/expenses/categories';
      } else if (menuName === 'EXPENSES' || menuName === 'EXPENSE_LIST') {
        childPath = PATHS.EXPENSES || '/expenses';
      } else if (menuName === 'INCOME_DASHBOARD' || menuName === 'INCOMES_DASHBOARD') {
        childPath = PATHS.INCOME_DASHBOARD || '/income/dashboard';
      } else if (menuName === 'INCOME_CATEGORY' || menuName === 'INCOME_CATEGORIES') {
        childPath = PATHS.INCOME_CATEGORIES || '/income/categories';
      } else if (menuName === 'INCOMES' || menuName === 'INCOME_LIST') {
        childPath = PATHS.INCOMES || '/income';
      } else if (menuName === 'MY_ATTENDANCE' || menuName === 'MY-ATTENDANCE' || menu.route === '/attendance/my_attendance' || menu.route === '/attendance/my-attendance') {
        childPath = PATHS.MY_ATTENDANCE || '/attendance/my-attendance';
      } else if (
        menuName === 'MY_ATTENDANCE_HISTORY' ||
        menuName === 'MY-ATTENDANCE-HISTORY' ||
        menuName === 'MY_HISTORY' ||
        menu.route === '/attendance/my_attendance_history' ||
        menu.route === '/attendance/my_history' ||
        menu.route === '/attendance/my-history'
      ) {
        childPath = PATHS.ATTENDANCE_MY_HISTORY || '/attendance/my-history';
      } else {
        childPath = menu.route || mapped?.path || '#';
      }

      const childIcon = ICON_MAP[menu.icon] || mapped?.icon || List;

      if (childPath && childPath !== '#') {
        children.push({
          id: menu.id || `menu-${menuName}`,
          title: childTitle,
          path: childPath,
          icon: childIcon,
        });
      }
    });

    if (children.length > 0) {
      navItems.push({
        id: modData.id || `module-${modName}`,
        title: modDisplayName,
        path: children[0]?.path || '#',
        icon: modIcon,
        children: children.length > 1 ? children : undefined,
      });
    } else {
      navItems.push({
        id: modData.id || `module-${modName}`,
        title: modDisplayName,
        path: modData.route || (modName.includes('EXPENSE') ? (PATHS.EXPENSES || '/expenses') : modName.includes('INCOME') ? (PATHS.INCOMES || '/income') : '#'),
        icon: modIcon,
      });
    }
  });

  return navItems;
}
